import template from './helloPackDocumentRequest.html';
import controller from './helloPackDocumentRequestCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    model: '<',
  },
};
